/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { OriginService } from './OriginService';

class OriginServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new OriginService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { OriginServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/OriginServiceProvider.js